import { render } from "./BidAddEditForm.vue?vue&type=template&id=31d37aac&scoped=true&lang=pug"
import script from "./BidAddEditForm.vue?vue&type=script&lang=ts"
export * from "./BidAddEditForm.vue?vue&type=script&lang=ts"

import "./BidAddEditForm.vue?vue&type=style&index=0&id=31d37aac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-31d37aac"

export default script